import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "autocomplete-popup__input-container-group q-input-group q-mb-1 q-input-group-lg q-d-flex q-flex-nowrap",
  role: "search",
  "aria-label": "Wyszukiwanie"
}

import {computed, nextTick, onMounted, onUnmounted, ref, watch} from 'vue'
import {storeToRefs} from "pinia";
import SearchInput from "@/components/SearchInput.vue";
import ClosePopupButton from './ClosePopupButton.vue'
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";
import {useMobileViewStore} from "@/store/MobileViewStore";
import {useBridgeStore} from "@/store/BridgeStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'AutocompleteInputContainer',
  setup(__props) {

const popupStore = usePopupStore()
const {showAutocompletePopup} = storeToRefs(popupStore)

const mobileViewStore = useMobileViewStore()
const {isMobileView} = storeToRefs(mobileViewStore)

const bridgeStore = useBridgeStore()

const desktopInputRef = ref<InstanceType<typeof SearchInput> | null>(null)
const mobileInputRef = ref<InstanceType<typeof SearchInput> | null>(null)

const isBridgeActive = computed(() => bridgeStore.hasClientInput)

const shouldRenderDesktopInput = computed(() => !isMobileView.value && !isBridgeActive.value)
const shouldRenderMobileInput = computed(() =>
  isMobileView.value && (!isBridgeActive.value || showAutocompletePopup.value)
)

const focusActiveInput = () => {
  if (isMobileView.value) {
    mobileInputRef.value?.focusInput()
    return
  }

  if (!isBridgeActive.value) {
    desktopInputRef.value?.focusInput()
  }
}

watch(showAutocompletePopup, async (isOpen) => {
  if (!isOpen) {
    return
  }

  await nextTick()
  focusActiveInput()
})

watch(isMobileView, (isMobile) => {
  if (isMobile && showAutocompletePopup.value) {
    nextTick(() => focusActiveInput())
  }
})

onMounted(() => {
  bridgeStore.registerInternalInputFocusHandler(focusActiveInput)
})

onUnmounted(() => {
  bridgeStore.clearInternalInputFocusHandler()
})

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(showAutocompletePopup))
      ? (_openBlock(), _createBlock(ClosePopupButton, { key: 0 }))
      : _createCommentVNode("", true),
    (shouldRenderDesktopInput.value)
      ? (_openBlock(), _createBlock(SearchInput, {
          key: 1,
          ref_key: "desktopInputRef",
          ref: desktopInputRef,
          autocomplete: true,
          context: "desktop"
        }, null, 512))
      : _createCommentVNode("", true),
    (shouldRenderMobileInput.value)
      ? (_openBlock(), _createBlock(SearchInput, {
          key: 2,
          ref_key: "mobileInputRef",
          ref: mobileInputRef,
          autocomplete: true,
          context: "mobile"
        }, null, 512))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, !_unref(isMobileView) || !isBridgeActive.value || _unref(showAutocompletePopup)]
  ])
}
}

})